import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const ResizingImage = (props) => {
    const { title, src, alt, size, fill, className, willResize } = props;
    const [height, setHeight] = useState(size);
    const width = size;

    return (
        <div className={classNames(styles.image, className)}>
            <img title={title} src={src} alt={alt} style={{ width: `${width}px`, objectFit: 'contain' }} />
        </div>
    );
};

export default ResizingImage;
